import { render } from "./OwnerTemporaryActionsDialog.vue?vue&type=template&id=776546eb"
import script from "./OwnerTemporaryActionsDialog.vue?vue&type=script&lang=js"
export * from "./OwnerTemporaryActionsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__